import { Component, input, Input } from '@angular/core';

@Component({
  selector: 'sb-ghost-list',
  templateUrl: './sb-ghost-list.component.html',
  styleUrls: ['./sb-ghost-list.component.scss'],
  standalone: false,
})
export class SbGhostListComponent {
  @Input() ghosts: any[] = [];
  isSplitscreen = input(false);
  isCardDisplay = input<boolean>(false);
}
